import { createContext, Dispatch, SetStateAction } from 'react';
import IMainForm from 'rules/interface/context/main-form-context.interface';


interface IContext {
    values: IMainForm
    setValues: Dispatch<SetStateAction<IMainForm>>
}

const MainFormContext = createContext<IContext>({
    values: {
        _id: null,
        step: 0,
        nextStep: () => undefined,
        prevStep: () => undefined,
    },
    setValues: () => undefined
});

export default MainFormContext